import { render, staticRenderFns } from "./PageCashCouponCoupons.vue?vue&type=template&id=f9c454ac&scoped=true"
import script from "./PageCashCouponCoupons.vue?vue&type=script&lang=js"
export * from "./PageCashCouponCoupons.vue?vue&type=script&lang=js"
import style0 from "./PageCashCouponCoupons.vue?vue&type=style&index=0&id=f9c454ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c454ac",
  null
  
)

export default component.exports